define([
	"dojo/_base/declare"
], function(dojoDeclare) {

	var	pluginRegistry = {};
	
	return {
		create: function(/*String*/name, /*Object*/params) {
			// summary: create plugin by name
			var	ctr = pluginRegistry[name];
			return ctr ? new ctr(params) : null;
		},
		
		declare: function(/*Object[]*/base, /*Object*/params) {
			// summary: declare class and register as plugin
			var	name = params.pluginName;
			var	ctr = dojoDeclare(base, params);
			pluginRegistry[name] = ctr;
			return ctr;
		}
	};
});